"use client";
import { styled } from "@mui/material/styles";
import { getUrls } from "@portal/app/_common/lib/urls";
import { useAuthenticatedContext } from "@portal/app/_components/context/AuthenticatedContext";
import { DreamLogo } from "../../DreamLogo";

export const NavLogo = ({
  isMobileMenuOpen,
  isOnDarkBackground = false,
}: {
  isMobileMenuOpen: boolean;
  // If True, the logo is darkened, and the text button color is inverted.
  // this is to support full bleed on pages with a dark top section
  isOnDarkBackground?: boolean;
}) => {
  const {
    role: { activeRole },
  } = useAuthenticatedContext();
  const urls = getUrls(activeRole);

  return (
    // Do not update this. Because our homepage is deployed in Webflow, it needs
    // to use an anchor tag instead of a Next Link.
    <a href={urls.Home()}>
      <Logo isOnDarkBackground={isOnDarkBackground && !isMobileMenuOpen} />
    </a>
  );
};

const Logo = styled(DreamLogo)`
  &.is_affiliate {
    width: 28px;
    overflow: hidden;
  }
`;
